const getEnv = () => {
  const { hostname } = window.location

  if (hostname === 'business.mall.linkiebuy.com') {
    return {
      env: 'prod',
      newHost: 'https://store.linkiebuy.com'
    }
  }

  if (hostname.includes('test.std')) {
    return {
      env: 'test',
      newHost: 'http://linkiebuy.test1.static.mall.xy'
    }
  }
  
  if (hostname.includes('fix.std')) {
    return {
      env: 'fix',
      newHost: 'http://linkiebuy.fix1.static.mall.xy'
    }
  }

  if (hostname.includes('dev.std')) {
    return {
      env: 'dev',
      newHost: 'http://linkiebuy.dev1.static.mall.xy'
    }
  }

  return {
    env: 'local',
    newHost: 'http://linkiebuy.dev1.static.mall.xy'
  }
}

const envConfig = getEnv()

export default envConfig